import {toast} from "sonner";

export default function sendSuccessAlert(text) {
    toast.success(text);
}

export function sendErrorAlert(text) {
    toast.error(text);
}
